((OptionsDropdown, $) => {
  'use strict';

  const $dom = {};

  const cacheDom = () => {
    $dom.optionsWrapper = $('.js-desktop-options-wrapper');
    $dom.dropdownToggle = $dom.optionsWrapper.find('.js-desktop-options-toggle');
    $dom.dropdown = $dom.optionsWrapper.find('.js-desktop-options-dropdown');
    $dom.moreDropdown = $('.js-more-dropdown');
  };

  const toggle = () => {
    $dom.dropdown.slideToggle();
    $dom.optionsWrapper.toggleClass('is-open');
  };

  const clickBinds = () => {
    $dom.dropdownToggle.on('click', () => {
      toggle();
    });

    $dom.moreDropdown.on('click', () => {
      if ($dom.dropdown.is(':visible')) {
        $dom.dropdown.slideUp();
      }
    });
  };

  const bindUIActions = () => {
    clickBinds();
  };

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  OptionsDropdown.init = init;
  OptionsDropdown.toggle = toggle;
})(window.OptionsDropdown = window.OptionsDropdown || {}, jQuery);
